export default __webpack_public_path__ + "static/media/2412312.638ec2b9.webp";